import { useKeycloak } from '@react-keycloak/web'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { publicRoutes } from '../api/components-examples/Routes/routes'

const NoSignInRequired = props => {
  const { initialized, keycloak } = useKeycloak()

  useEffect(() => {
    if (
      initialized &&
      keycloak.authenticated &&
      publicRoutes.includes(props.location.pathname) &&
      !props.checkUberDeployment.isLoading &&
      props.checkUberDeployment &&
      props.checkUberDeployment.status !== undefined
    ) {
      return <Redirect to={`/organizations`} />
    }
  }, [initialized])

  if (initialized && !keycloak.authenticated) {
    return <div>{props.children}</div>
  } else return null
}
export default connect(state => state)(NoSignInRequired)
